module.exports = __webpack_public_path__ + "static/media/Logo1-1.241ed799.svg";